import { Box, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import Breadcrumbs from "../../components/Shared/Breadcrumbs/Breadcrumbs";
import LoadingIndicator from "../../components/Shared/LoadingIndicator/LoadingIndicator";
import { ResponseTimeStatsLogsBreadcrumbs } from "../../configs/breadcrumbNavigation";
import { useDevResponseTimeStats } from "../../networking/dev-log.hooks";
import AppText from "../../components/Core/AppText/AppText";

const ResponseTimeStatsPage: React.FC = () => {
	const { data, isLoading } = useDevResponseTimeStats();

	return (
		<>
			<Breadcrumbs items={ResponseTimeStatsLogsBreadcrumbs} />
			<div className="p-4 px-6">
				<Box>
					{isLoading ? (
						<LoadingIndicator />
					) : (
						<VStack align={"flex-start"} w="full">
							<Heading size="md" mt="2">
								Response time by method (last 24h)
							</Heading>
							<HStack py="1">
								<Text fontWeight={"semibold"}>GET:</Text>
								<Text>
									{data?.byMethod.GET.count} requests, avg {data?.byMethod.GET.avg.toFixed()} ms
								</Text>
							</HStack>

							<HStack py="1">
								<Text fontWeight={"semibold"}>POST:</Text>
								<Text>
									{data?.byMethod.POST.count} requests, avg {data?.byMethod.POST.avg.toFixed()} ms
								</Text>
							</HStack>

							<HStack py="1">
								<Text fontWeight={"semibold"}>PUT:</Text>
								<Text>
									{data?.byMethod.PUT.count} requests, avg {data?.byMethod.PUT.avg.toFixed()} ms
								</Text>
							</HStack>

							<HStack py="1">
								<Text fontWeight={"semibold"}>DELETE:</Text>
								<Text>
									{data?.byMethod.DELETE.count} requests, avg {data?.byMethod.DELETE.avg.toFixed()}{" "}
									ms
								</Text>
							</HStack>

							<HStack bg="white" py="1">
								<Text fontWeight={"semibold"}>Total:</Text>
								<Text>
									{data?.total.count} requests, avg {data?.total.avg.toFixed()} ms
								</Text>
							</HStack>

							<Heading size="md" mt="6">
								Top slow endpoints (last 24h)
							</Heading>
							{(data?.topSlowResponses || []).map((item, index) => (
								<HStack key={index} py="1">
									<Text>
										{item.method} {item.path}
									</Text>
									<Text>{item.ms} ms</Text>
								</HStack>
							))}
						</VStack>
					)}
				</Box>
			</div>
		</>
	);
};

export default ResponseTimeStatsPage;
